import styled from 'styled-components';
import { mq, setGridColumns, gridContainer, getFixedSpace } from '../../../stylesheets/tools';

const StyledTeaserShaped = styled.div`
  .teaser__container {
    position: relative;
    align-items: center;
    ${gridContainer()}
    ${setGridColumns('1fr', 1)}
    gap: 30px;

    ${mq('m')} {
      gap: 80px;
      ${setGridColumns('1fr', 2)}
    }

    .teaser__image {
      img {
        aspect-ratio: 5/3;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .teaser__content {
      .teaser__headlines {
        margin-bottom: ${getFixedSpace('xs')};

        h3 {
          margin-bottom: ${getFixedSpace('xxxs')};
        }
      }
      p {
        margin-bottom: ${getFixedSpace('xxs')};
      }
    }
  }
`;

export default StyledTeaserShaped;
